module.exports = __webpack_public_path__ + "img/ticket_icon.1cf1e26a.svg";